export class EvlFailedToConnectError extends Error {
    constructor(msg?: string) {
        super(msg);
        Object.setPrototypeOf(this, EvlFailedToConnectError.prototype);
    }
}

/**
 * Thrown by `startConferenceWithEndpointArn` when the contact can't accept a conferenced party yet:
 * the contact or the customer leg is not CONNECTED (e.g. Play pressed during a callback before the
 * customer answered). Distinct from {@link DisclosureInFlightError} so callers can categorize the
 * cause (connectivity vs concurrency) without parsing error strings.
 */
export class DisclosureContactNotReadyError extends Error {
    constructor(message?: string, options?: ErrorOptions) {
        super(message, options);
        this.name = "DisclosureContactNotReadyError";
        // No Object.setPrototypeOf: verified the rolldown build emits this as a native `class extends
        // Error` at Vite's `build.target` (not downleveled), so the prototype chain — and the `instanceof`
        // check the onPlayDisclosure boundary relies on — is correct without it.
        Error.captureStackTrace?.(this, DisclosureContactNotReadyError);
    }
}

/**
 * Thrown by `startConferenceWithEndpointArn` when a disclosure conference is already in flight, so a
 * second one must not be started. Distinct from {@link DisclosureContactNotReadyError} — this is a
 * concurrency condition, not a connectivity one.
 */
export class DisclosureInFlightError extends Error {
    constructor(message?: string, options?: ErrorOptions) {
        super(message, options);
        this.name = "DisclosureInFlightError";
        // No Object.setPrototypeOf — see DisclosureContactNotReadyError above (native class at Vite's `build.target`).
        Error.captureStackTrace?.(this, DisclosureInFlightError);
    }
}
